// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xh-1";
export var printerIcon = "_xh-0";